import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const env = import.meta.env;

export const app = initializeApp({
  apiKey: env.VITE_FIREBASE_API_KEY,
  projectId: env.VITE_FIREBASE_PROJECT_ID,
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
  appId: env.VITE_FIREBASE_APP_ID,
});

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'europe-west3');

if (env.VITE_USE_EMULATORS === 'true') {
  connectAuthEmulator(auth, env.VITE_EMULATOR_AUTH ?? 'http://localhost:9099', {
    disableWarnings: true,
  });
  connectFirestoreEmulator(
    db,
    env.VITE_EMULATOR_FIRESTORE_HOST ?? 'localhost',
    Number(env.VITE_EMULATOR_FIRESTORE_PORT ?? 8080),
  );
  connectStorageEmulator(
    storage,
    env.VITE_EMULATOR_STORAGE_HOST ?? 'localhost',
    Number(env.VITE_EMULATOR_STORAGE_PORT ?? 9199),
  );
  connectFunctionsEmulator(
    functions,
    env.VITE_EMULATOR_FUNCTIONS_HOST ?? 'localhost',
    Number(env.VITE_EMULATOR_FUNCTIONS_PORT ?? 5001),
  );
}
